import { render, staticRenderFns } from "./DocumentDisplay.vue?vue&type=template&id=11647a06"
import script from "./DocumentDisplay.ts?vue&type=script&lang=ts&external"
export * from "./DocumentDisplay.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports